import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  wrapper: {
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-around',
    },
  },
}))
